// extracted by mini-css-extract-plugin
module.exports = {"container":"temperature-module--container--3AaoE"};